import script from "./QuestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionList.vue?vue&type=script&setup=true&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=6c5dde24&scoped=true&lang=css"
script.__scopeId = "data-v-6c5dde24"

export default script